// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"522":"3b8cac07","543":"8fe1fab2","736":"f4d38eb1"}[chunkId] + ".chunk.css";
};